export class AirTimeRegistrationToken {
  static IAirTimeRegistrationRepository = Symbol(
    "IAirTimeRegistrationRepository"
  );
  static AirTimeRegistrationViewModel = Symbol("AirTimeRegistrationViewModel");
  static AirTimeRegistrationUseCase = Symbol("AirTimeRegistrationUseCase");
}
